/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarylinkcopied3Inputs */

const en_medialibrarylinkcopied3 = /** @type {(inputs: Medialibrarylinkcopied3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied.`)
};

const de_medialibrarylinkcopied3 = /** @type {(inputs: Medialibrarylinkcopied3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopiert.`)
};

/**
* | output |
* | --- |
* | "Link copied." |
*
* @param {Medialibrarylinkcopied3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarylinkcopied3 = /** @type {((inputs?: Medialibrarylinkcopied3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarylinkcopied3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarylinkcopied3(inputs)
	return de_medialibrarylinkcopied3(inputs)
});
export { medialibrarylinkcopied3 as "mediaLibraryLinkCopied" }